var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 20H22","stroke":"#C6D7FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M9 12H31","stroke":"#C6D7FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M9 28H31","stroke":"#C6D7FF","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

BurgerMenu.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
